import React, {useEffect, useState} from "react";
import { isMobile } from "../../globals/helpers";
import HomepageMob from "../HomepageMob/HomepageMob";
import Homepage from "../Homepage/Homepage";
import { primaryInput } from "detect-it";
import HomepageTs from "../HomepageTs/HomepageTs";
import { useLocation } from 'react-router-dom';

const HomepageWrapper = ({setCursorText, controlAuxCursor, isFirstLoad, setIsHomeScreen, setTriggerHomepageToProjectTransition, setTriggerArchiveToHomepageTransition, setHomeToArchiveTransitionTrigger}) => {
    const [isMobView, setIsMobView] = useState(true);
    const [isTouchScreen, setIsTouchScreen] = useState(null);
    const [isFromArchive, setIsFromArchive] = useState(null);
    const location = useLocation();


    function responsiveResize(){
        let curHeight = window.innerHeight;
        let curWidth = window.innerWidth;
        setIsMobView(isMobile(curWidth, curHeight, true))
    }
    useEffect(() => {
        responsiveResize();
        window.addEventListener('resize', responsiveResize, false);

        if(primaryInput !== 'mouse') setIsTouchScreen(true); else setIsTouchScreen(false);

        try{
            let tmpRes = location.state.isFromArchive;
            if(tmpRes){
                setIsFromArchive(true);
            }
        } catch{setIsFromArchive(false)}

        setTimeout(() => {
            setTriggerArchiveToHomepageTransition(false);
        }, 150)

        return() => {
            setTriggerHomepageToProjectTransition(false);
            window.removeEventListener('resize', responsiveResize);
        }
    }, [])

    return(
        <>
        {
            isTouchScreen ? 
                isMobView ? 
                    <HomepageMob
                        isFirstLoad={isFirstLoad}
                    />
                :
                    <HomepageTs
                        setTriggerHomepageToProjectTransition={setTriggerHomepageToProjectTransition}
                        setHomeToArchiveTransitionTrigger={setHomeToArchiveTransitionTrigger}
                        isFromArchive={isFromArchive}
                        isFirstLoad={isFirstLoad}
                    />
            :
                isTouchScreen !== null &&
                <Homepage 
                    setCursorText={setCursorText}
                    controlAuxCursor={controlAuxCursor}
                    setIsHomeScreen={setIsHomeScreen}
                    setTriggerHomepageToProjectTransition={setTriggerHomepageToProjectTransition}
                    setHomeToArchiveTransitionTrigger={setHomeToArchiveTransitionTrigger}
                    isFromArchive={isFromArchive}
                    isFirstLoad={isFirstLoad}
                />
        }
        </>
    )
}

export default HomepageWrapper;